<template>
  <div :class="`component hb-div-width ${className}`" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    className:{
      type: String,
      default: () => {
        return ''
      }
    },
    modifyStyle: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      style: ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.init()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    init () {
      if (this.modifyStyle) {
        this.style = this.modifyStyle
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.component.hb-div-width {}
</style>
